/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';

export namespace AgentDetailsListWrapper {
  export interface Props extends React.HTMLAttributes<HTMLUListElement> {}
}

const styles = StyleSheet.create({
  agentDetailsListWrapper: {
    margin: 0,
    padding: 0,
    listStyleType: 'none',
  },
});

export const AgentDetailsListWrapper: React.FC<AgentDetailsListWrapper.Props> = ({ children, ...htmlProps }) => {
  return (
    <ul className={css(styles.agentDetailsListWrapper)} {...htmlProps}>
      {children}
    </ul>
  );
};
